import axios from "axios";
import routes from "../../configs/api";
import getCouponAuthHeaders from "./couponAuthHeaders";

const getCoupons = ({ search = "", sortField = "createdAt", sortOrder = "desc", page = 1, limit = 10 }) => {
  const params = new URLSearchParams({ search, sortField, sortOrder, page, limit });
  const URL = `${routes.GET_COUPONS}?${params.toString()}`;

  return new Promise((resolve, reject) => {
    let headers;

    try {
      headers = getCouponAuthHeaders();
    } catch (error) {
      reject(error);
      return;
    }

    axios
      .get(URL, {
        headers,
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export default getCoupons;
